import PropTypes from 'prop-types';
import styles from './FJSceneTextItem.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import FJDragIcon from '../../../assets/svg/textToVideo/drag.svg?react';
import FJAddSceneIcon from '../../../assets/svg/textToVideo/add-scene.svg?react';
import FJDeleteIcon from '../../../assets/svg/textToVideo/delete.svg?react';
import FJHandle from '../../../common/components/FJHandle/FJHandle';
import { useRef, useEffect } from 'react';
import classNames from 'classnames';
import { FJ_EVENT_TYPE } from '../../../constants/FJEvenTypeConstant';
import FJAutoTextarea from '../../../common/components/FJAutoTextarea/FJAutoTextarea';
import { MAX_SCENE_TEXT_LENGTH } from '../../../config/dataConfig/FJTextToVideoDataConfig';
import FJEvent from '../../../store/FJEvent.js';
import FJToolTip from '../../../common/components/FJToolTip/FJToolTip';

const FJSceneTextItem = props => {
    const { item, index, onDrag, isDragging, dragId, style, updateSceneTextList } = props;
    const { id, text } = item;
    const autoTextareaRef = useRef(null);

    useEffect(() => {
        const un = FJEvent.subscribe(FJ_EVENT_TYPE.SET_SCENE_FOCUS, ({ focusId, cursorPosition }) => {
            if (autoTextareaRef.current && focusId === id) {
                autoTextareaRef.current.focus(cursorPosition);
            }
        });
        return () => {
            un();
        };
    }, [id]);

    const _onDragStart = e => {
        e.preventDefault();
        onDrag(e, 'start', { dragId: id });
    };
    const _onDragging = e => {
        document.body.style.cursor = 'grabbing';
        onDrag(e, 'change', { dragId: id });
    };

    const _onDragEnd = e => {
        onDrag(e, 'end', { dragId: id });
    };

    const _onChange = value => {
        updateSceneTextList(id, { type: FJ_EVENT_TYPE.EDIT, textValue: value });
    };
    const _onSplit = idx => {
        updateSceneTextList(id, { type: FJ_EVENT_TYPE.SPLIT, splitIdx: idx });
    };
    const _mergePrev = () => {
        updateSceneTextList(id, { type: FJ_EVENT_TYPE.MERGE_PREV });
    };
    const _onDelete = () => {
        updateSceneTextList(id, { type: FJ_EVENT_TYPE.DELETE });
    };
    const _add = () => {
        updateSceneTextList(id, { type: FJ_EVENT_TYPE.ADD });
    };

    return (
        <div
            className={classNames(
                styles.content_item,
                {
                    [styles.dragging]: dragId === id,
                    [styles.hover]: !isDragging,
                },
                'ttv_drag_item',
            )}
            style={style}
            id={`scene-text-item-${index}`}
        >
            <FJHandle
                style={{ display: 'block', cursor: 'grabbing' }}
                onDragStart={_onDragStart}
                onDrag={_onDragging}
                onDragEnd={_onDragEnd}
                render={() => {
                    return (
                        <div className={styles.content_item_title}>{FJLocalStore._('scene') + ' ' + (index + 1)}</div>
                    );
                }}
            />

            <FJAutoTextarea
                onChange={_onChange}
                onSplit={_onSplit}
                mergePrev={_mergePrev}
                onDelete={_onDelete}
                text={text}
                ref={autoTextareaRef}
                maxLength={MAX_SCENE_TEXT_LENGTH}
            />
            <div className={styles.delete_box} onClick={_onDelete}>
                <FJDeleteIcon />
            </div>

            <div className={styles.overlay_box}>
                <div className={styles.item_icon_box}>
                    <FJToolTip placement='top' title={FJLocalStore._('add-scene')}>
                        <div>
                            <FJAddSceneIcon onClick={_add} />
                        </div>
                    </FJToolTip>
                    <FJHandle
                        style={{ display: 'block' }}
                        onDragStart={_onDragStart}
                        onDrag={_onDragging}
                        onDragEnd={_onDragEnd}
                        render={() => {
                            return (
                                <FJToolTip placement='top' title={FJLocalStore._('drag-to-move')}>
                                    <div>
                                        <FJDragIcon className={classNames(styles.drag)} />
                                    </div>
                                </FJToolTip>
                            );
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

FJSceneTextItem.propTypes = {
    item: PropTypes.object,
    index: PropTypes.number,
    onDrag: PropTypes.func,
    dragId: PropTypes.any,
    isDragging: PropTypes.bool,
    style: PropTypes.object,
    updateSceneTextList: PropTypes.func,
};

export default FJSceneTextItem;
